import React from 'react';
import styles from '../style/ThresholdModal.module.css';
import viewerStyles from '../style/ReportViewer.module.css';

function ReportViewerModal({ isOpen, onClose, report }) {
    if (!isOpen || !report) return null;

    const reportData = report.report_data || [];
    const headers = reportData.length > 0 ? Object.keys(reportData[0]) : [];

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={`${styles.modalContent} ${viewerStyles.viewerModalContent}`} onClick={e => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    {/* Translated: Report -> Bericht */}
                    <h2>Bericht: {report.report_name}</h2>
                    <button onClick={onClose} className={styles.closeButton}>×</button>
                </div>
                <div className={`${styles.modalBody} ${viewerStyles.viewerBody}`}>
                    {reportData.length > 0 && reportData[0].Status ? (
                        <p>{reportData[0].Status}</p>
                    ) : (
                        <table className={viewerStyles.viewerTable}>
                            <thead>
                                <tr>
                                    {headers.map(header => <th key={header}>{header}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {reportData.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {headers.map(header => (
                                            <td key={`${rowIndex}-${header}`}>
                                                {/* Format timestamp for readability */}
                                                {header.toLowerCase().includes('timestamp') 
                                                    ? new Date(row[header]).toLocaleString('de-DE') // Added 'de-DE' for German format
                                                    : row[header]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    {/* Translated: Close -> Schließen */}
                    <button onClick={onClose} className={styles.cancelButton}>Schließen</button>
                </div>
            </div>
        </div>
    );
}

export default ReportViewerModal;